import React from "react";
import Img from "gatsby-image";
import { Link } from "gatsby";
import styled from "styled-components";


const ObradniSineInner = styled.div`
  padding: 60px 0;
  background: #F4F3F0;
  margin: 0px auto;

  @media (max-width: 899px) {
    padding: 40px 0;
  }

  h2 {
    font-family: Ivar;
    font-size: 32px;
    color: #000000;
    text-align: center;
    margin: 0 auto;
    margin-bottom: 60px;
    width: calc(100% - 50px);

    @media (max-width: 899px) {
      font-size: 25px;
      line-height: 35px;
      margin-bottom: 40px;
    }
  }

  .sin {
    background: #FFFFFF;
    box-shadow: 0 9px 20px 0 rgba(0,0,0,0.07);
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    padding: 40px 80px;
    width: calc(100% - 160px - 100px);
    max-width: calc(1150px - 160px);
    margin: 20px auto;
    align-items: center;

    @media (max-width: 1100px) {
      padding: 40px 40px;
      max-width: calc(1150px - 80px);
      width: calc(100% - 80px - 100px);
    }

    @media (max-width: 899px) {
      display: block;
      width: calc(100% - 80px - 50px);
    }

    @media (max-width: 500px) {
      padding: 20px;
      width: calc(100% - 40px - 50px);
    }

    .left {
      width: calc(100% - 350px);

      @media (max-width: 899px) {
        width: calc(100%);
        margin-bottom: 30px;
      }

      h3 {
        font-family: Ivar;
        font-size: 27px;
        color: #000000;
        line-height: 37px;
        margin-bottom: 25px;

        @media (max-width: 899px) {
          font-size: 22px;
          line-height: 29px;
          margin-bottom: 20px;
        }

        a {
          font-family: Ivar;
          color: #000000;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      p {
        font-family: Visuelt-Regular;
        font-size: 16px;
        color: #5A5A5A;
        line-height: 25px;

        a {
          text-decoration: underline;
          color: #5A5A5A;
        }
      }
    }

    .right {
      width: 300px;
      
      @media (max-width: 500px) {
        width: 100%;
      }
    }
  }
`;


const ObradniSine = ({
  sine,
  h2
}) => {
  return (
    <ObradniSineInner>
      <h2>{h2}</h2>

      {sine.map(s => {
        return(
          <div className="sin" key={s.link}>
            <div className="left">
              {s.link === "" ?
                <h3>{s.h3}</h3>
              :
                <h3><Link to={s.link}>{s.h3}</Link></h3>
              }
              <p>{s.text}</p>
            </div>
            <div className="right">
              <Img alt={s.h3} fluid={s.img} />
            </div>
          </div>
        );
      })}
    </ObradniSineInner>
  );
}

export default ObradniSine;


